import React, { useState } from 'react';
import config from '../../config';
import css from './RiderInterestsFormFields.css';

import { INTEREST_COMPETITION } from '../../marketplace-custom-config';
import { Alert, FieldCheckbox } from '../../components';
import { useScrollToAlert } from './useScrollToAlert';

const {
    custom: { activities },
} = config;

const RiderInterestsFormFields = ({ values, form }) => {
    const [alertRef, setRef] = useState(null);

    const { interest: interestSelected } = values || {};

    const hasCompetitionValue = interestSelected?.some(i => i === INTEREST_COMPETITION);

    useScrollToAlert(hasCompetitionValue, alertRef);

    return (
        <>
            <section>
                {activities.map(({ key, value }) => (
                    <FieldCheckbox
                        type="checkbox"
                        key={key}
                        id={value}
                        name="interest"
                        label={value}
                        value={value}
                        form={form}
                    />
                ))}
            </section>
            {hasCompetitionValue && (
                <Alert
                    rootRef={setRef}
                    showAsPlainText
                    closeAllowed
                    rootClassName={css.alert}
                    closeClassName={css.closeButton}
                    header="Wichtiger Hinweis"
                    description="Wähle das Interesse „Turniere“ nur aus, wenn es dir beim Matching besonders wichtig ist."
                />
            )}
        </>
    );
};

export default RiderInterestsFormFields;
